module.exports = __webpack_public_path__ + "static/media/DIEM_MY.ad7ccb99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/DIEM_MY.jpg
// module id = 1116
// module chunks = 0